import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules';

Vue.use(Vuex);

const getters = {
    publisher: state => state.publisher.active,
    integration: state => state.integration.active,
    products: state => state.products.all,
    product: state => state.products.active,
    chapter: state => state.chapters.active,
    assignment: state => state.assignments.active,
    question: state => id => state.assignments.questions.get(id)
};

export default new Vuex.Store({
    modules,
    getters,
    strict: process.env.NODE_ENV !== 'production'
});
